module.exports = __webpack_public_path__ + "static/media/Dickinson_RED_PMS186.3c4dad42.png";